// extracted by mini-css-extract-plugin
export var searchHeader = "_6v-0";
export var searchHeaderDark = "_6v-1";